import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useNavigate, useLocation } from "react-router-dom";
import { logout } from '../services/authService';
import verifiedGreen from '../icon/verifiedGreen.png';
import verifiedGrey from '../icon/verifiedGrey.png';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Button,
  Tabs,
  Tab,
  useMediaQuery,
  useTheme,
  Autocomplete,
  TextField,
  Divider,
} from "@mui/material";

// 17/11
import maleImg from "../icon/male.png";
import femaleImg from "../icon/female.png";
import buildingImg from "../icon/building.png";


import defualtuser from "../icon/user2.png";
import coapplicant from "../icon/applicantimage.jpg";
import proprietor from "../icon/applicantimage.jpg";
import homeicon from "../icon/homeicon.png";
import applicanticon from "../icon/Profile.png";
import phoneicon from "../icon/phone.png";
import applicationicon from "../icon/greencircle.png";
import financeicon from "../icon/redcircle.png";
import panicon from "../icon/pan.png";
import emailicon from "../icon/email.png";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Appsummary from "../components/Appsummary";
import VerifiedIcon from "@mui/icons-material/Verified";
import { getApplicationDetails, getAllApplications } from "../api";
import { API_BASE } from '../api';
import EmptyState from "../components/EmptyState";
import Emptysummary from "../components/EmptySummary";


export default function ApplicationSummary() {
  const [collapsed, setCollapsed] = useState(true);
  const [activeTab, setActiveTab] = useState(0);
  const navigate = useNavigate();

  // Handle logout
  const handleLogout = async () => {
    console.log(' [SUMMARY] Logout initiated from sidebar');
    try {
      await logout('manual');
      // logout function handles redirect
    } catch (error) {
      console.error(' [SUMMARY] Logout error:', error);
      // Force logout even if API fails
      localStorage.clear();
      navigate('/login');
    }
  };
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState("");
  
  // Safety wrapper for setSelectedApplication to ensure only strings are set
  const safeSetSelectedApplication = (value) => {
    console.log(' [SAFE SET] Attempting to set selectedApplication:', value, 'Type:', typeof value);
    
    if (typeof value === 'string' && value.trim()) {
      const safeValue = value.trim();
      console.log(' [SAFE SET] Setting safe value:', safeValue);
      setSelectedApplication(safeValue);
    } else if (value && typeof value === 'object' && value.applicationNo) {
      const safeValue = String(value.applicationNo).trim();
      console.log('[SAFE SET] Extracting applicationNo:', safeValue);
      setSelectedApplication(safeValue);
    } else {
      console.log(' [SAFE SET] Invalid value, setting empty string');
      setSelectedApplication('');
    }
  };
  const [verifiedApplications, setVerifiedApplications] = useState(new Set());

  const [peopleCards, setPeopleCards] = useState([
    { name: "N/A", role: "Proprietor", phone: "N/A", pan: "N/A", email: "N/A", gender: null },
    { name: "N/A", role: "Co-Applicant", phone: "N/A", pan: "N/A", email: "N/A", gender: null },
    { name: "N/A", role: "Company", phone: "N/A", pan: "N/A", email: "N/A", gender: null },
  ]);

  const commonFieldStyles = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "2rem",
      height: "2.125rem", // Converted from 34px
      "& fieldset": { borderColor: "#034A7F" },
      "&:hover fieldset": { borderColor: "#034A7F" },
      "&.Mui-focused fieldset": { borderColor: "#034A7F" },
    },
    "& .MuiInputBase-input": { color: "#034A7F", py: 0.5, fontSize: "0.875rem" }, // Converted from 14px
    "& .MuiInputLabel-root": { color: "#034A7F", fontSize: "0.875rem" }, // Converted from 14px
    "& .MuiInputLabel-root.Mui-focused": { color: "#034A7F" },
  };



  const tabLabels = [
    "Profile Details",
    "Financial Details",
    "Bureau Details",
    "Credit Memo",
  ];

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  const [finalStatus, setFinalStatus] = useState("N/A");
  const [memoNo, setMemoNo] = useState("N/A");
  const [memoDate, setMemoDate] = useState("N/A");



  // profile detailstab
  const [profileDetailsFields, setProfileDetailsFields] = useState({
    left: [
      ["Full Name", "N/A"],
      ["Age", "N/A"],
      // ["Marital Status", "N/A"],
      ["City", "N/A"],
    ],
    right: [
      ["Business_name", "N/A"],
      ["Constitution_of_business", "N/A"],
      ["Date_of_incorporation", "N/A"],
      ["Nature_of_business", "N/A"],
    ],
  });
  useEffect(() => {
    if (!selectedApplication) return; // only fetch when ID exists

    const formatDate = (dateStr) => {
      if (!dateStr) return "N/A";

      // 🧹 Remove timestamp (everything after 'T')
      const cleanDate = dateStr.split("T")[0];

      const parts = cleanDate.split(/[-/]/);
      if (parts.length === 3) {
        // YYYY-MM-DD format
        if (parts[0].length === 4) {
          const [year, month, day] = parts;
          return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
        }

        // DD-MM-YYYY format (day > 12)
        if (parseInt(parts[0]) > 12) {
          const [day, month, year] = parts;
          return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
        }
      }

      return cleanDate; // fallback if no match
    };

    const fetchProfileDetails = async () => {
      try {
        // 🧩 Fetch both APIs at once
        const [prRes, bizRes, natureres] = await Promise.all([
          fetch(`${API_BASE}/individuals/${selectedApplication}/scores`),
          fetch(`${API_BASE}/applications/${selectedApplication}/individuals`),
          fetch(`${API_BASE}/silver/loanapplications/${selectedApplication}`),
        ]);

        const prData = await prRes.json();
        const bizData = await bizRes.json();
        const naturedata = await natureres.json();

        // 🪵 Print business/company API result for debugging
        console.log(" Business / Company API Response:", bizData);
        console.log(" nature API Response:", naturedata);


        if (prData.success) {
          const pr = prData.data?.proprietor || {};
          const businessInfo = bizData.company || {};
          const natureInfo = naturedata.data || {};

          // //  Try to merge data from both APIs
          // const company = bizData?.individuals?.find(
          //   (ind) =>
          //     ind.roleCategory?.toUpperCase() === "COMP" ||
          //     ind.roleCategory?.toUpperCase() === "COMPANY"
          // );

          setProfileDetailsFields({
            left: [
              ["Full Name", pr?.name || "N/A"],
              ["Age", pr?.age || "N/A"], // only if backend sends age
              // ["Marital Status", "N/A"],
              ["City", pr?.city || "N/A"],
            ],
            right: [
              ["Business_name", businessInfo?.name || "N/A"],
              [
                "Constitution_of_business",
                businessInfo?.ConstitutionOfBusiness || "N/A",
              ],
              [
                "Date_of_incorporation",
                formatDate(businessInfo?.DateOfIncorporation) || "N/A",
              ],
              [
                "Nature_of_business",
                natureInfo?.natureOfBusiness || "N/A",
              ],
            ],
          });
        } else {
          console.error("PR API error:", prData.error);
        }
      } catch (error) {
        console.error("Failed to fetch profile details:", error);
      }
    };

    fetchProfileDetails();
  }, [selectedApplication]);

  //financialdetailstab
  const [financialDetailsFields, setFinancialDetailsFields] = useState({
    left: [
      ["ITR Income: PR (AY-24)", "N/A"],
      ["ITR Income: CO1 (AY-24)", "N/A"],
      ["Income Growth", "N/A"],
      ["Proprietor Net Worth", "N/A"],
    ],
    right: [
      ["Business Revenue (Annual)", "N/A"],
      ["Net Profit (Latest FY)", "N/A"],
      ["Net Profit Margin %", "N/A"],
      ["Sales Growth % (YoY)", "N/A"],
    ],
  });

  useEffect(() => {
    if (!selectedApplication) return;

    const fetchFinancialDetails = async () => {
      try {
        // 🧩 Fetch both APIs in parallel
        const [finRes, bankRes, comres, plres] = await Promise.all([
          fetch(`${API_BASE}/applications/${selectedApplication}/financials`),
          fetch(`${API_BASE}/applications/${selectedApplication}/bank-summary`),
          fetch(`${API_BASE}/applications/${selectedApplication}/company-financials`),
          fetch(`${API_BASE}/applications/${selectedApplication}/profit-loss`),
        ]);
        const finData = await finRes.json();
        const bankData = await bankRes.json();
        const comdata = await comres.json();
        const proandlossdata = await plres.json();

        console.log(" Financial API Response:", finData);
        console.log(" Bank Summary API Response:", bankData);
        console.log(" company Summary API Response:", comdata);
        console.log(" profitloss API Response:", proandlossdata);

        if (finData.success) {
          const pr = finData.financials?.pr?.[0] || {};
          const co1 = finData.financials?.co1?.[0] || {};
          //  Extract from Bank Summary API (first record)
          const bankInfo = bankData?.bankSummary || {};
          const companyFinancials = comdata?.companyFinancials || [];
          const comInfo = companyFinancials.length
            ? companyFinancials.reduce((latest, record) => {
              const latestYear = parseInt(latest.Assessment_Year || latest.YearID || 0);
              const currentYear = parseInt(record.Assessment_Year || record.YearID || 0);
              return currentYear > latestYear ? record : latest;
            })
            : {};
          const profitlossinfo = proandlossdata?.profitLoss || [];

          //  Get latest Assessment_Year record
          const latestProfitLoss = profitlossinfo
            .sort((a, b) => (b.Assessment_Year || "").localeCompare(a.Assessment_Year || ""))[0] || {};

          //  Extract key financial data
          const itrPR = pr.Latest_Total_Income || "N/A";
          const itrCO1 = co1.Latest_Total_Income || "N/A";
          const netWorth = pr.NetWorth || "N/A";
          const BusinessRevenue = comInfo.Total_Income || "N/A";
          const SalesGrowth = comInfo.SalesGrowth || "N/A";
          const netProfit_lt = latestProfitLoss.Net_Profit || "N/A";
          //  Calculate Net Profit Margin %
          const netProfitMargin =
            BusinessRevenue !== "N/A" && BusinessRevenue != 0
              ? ((parseFloat(netProfit_lt) / parseFloat(BusinessRevenue)) * 100).toFixed(2) + "%"
              : "N/A";


          //  Extract from Bank Summary API
          const incomeGrowth =
            pr.Income_Growth || "N/A";

          //  Combine and update UI fields
          setFinancialDetailsFields({
            left: [
              ["ITR Income: PR (AY-24)", itrPR],
              ["ITR Income: CO1 (AY-24)", itrCO1],
              ["Income Growth", incomeGrowth],
              ["Proprietor Net Worth", netWorth],
            ],
            right: [
              ["Business Revenue (Annual)", BusinessRevenue],
              ["Net Profit (Latest FY)", netProfit_lt],
              ["Net Profit Margin %", netProfitMargin],
              ["Sales Growth % (YoY)", SalesGrowth],
            ],
          });
        } else {
          console.error("Financial API error:", finData.error);
        }
      } catch (error) {
        console.error(" Failed to fetch financial details:", error);
      }
    };

    fetchFinancialDetails();
  }, [selectedApplication]);

  //buerudetailstab

  const [bureauDetailsFields, setBureauDetailsFields] = useState({
    left: [
      ["Score", "N/A"],
      ["Total Outstanding", "N/A"],
      ["Total Live tradelines", "N/A"],
      ["Bureau Age", "N/A"],
    ],
    right: [
      ["CMR Rank", "N/A"],
      ["Total Outstanding", "N/A"],
      ["DPD Months30+", "N/A"],
      ["Bureau Age", "N/A"],
    ],
  });


  useEffect(() => {
    if (!selectedApplication) return;

    const fetchBureauDetails = async () => {
      try {
        const [scoresRes, cibilRes, companyCibilRes] = await Promise.all([
          fetch(`${API_BASE}/individuals/${selectedApplication}/scores`),
          fetch(`${API_BASE}/silver/cibil/${selectedApplication}`),
          fetch(`${API_BASE}/silver/company-cibil/${selectedApplication}`),
        ]);

        const scoresData = await scoresRes.json();
        const cibilData = await cibilRes.json();
        const companyCibilData = await companyCibilRes.json();

        console.log(" Bureau Scores API Response:", scoresData);
        console.log(" Silver CIBIL API Response:", cibilData);
        console.log(" Company CIBIL API Response:", companyCibilData);

        if (scoresData.success) {
          // 🧍 Proprietor & Co-applicant scores
          const proprietor = scoresData.data?.proprietor || {};
          const coApplicant = scoresData.data?.coApplicant || {};

          const proprietorCB = proprietor.scores?.cb ?? "N/A";
          const co1CB = coApplicant.scores?.cb ?? "N/A";

          // Individual CIBIL data
          const cibilList = cibilData.data || {};
          const totalAccounts =
            cibilList.roleCategory?.toUpperCase() === "PR"
              ? cibilList.totalAccounts ?? "N/A"
              : "N/A";
          const totalAdvanceBalance = cibilList.roleCategory?.toUpperCase() === "PR"
            ? cibilList.totalAdvanceBalance ?? "N/A"
            : "N/A";
          const BureauAge = proprietor.BureauAge ?? "N/A"


          //  Company CIBIL data
          const companyCibil = companyCibilData.data || {};
          const DPD_Months30 =
            companyCibil.monthsSinceMostRecentDelinquency30PlusDpd ?? "N/A";
          const past6MonthsEnquiries = "N/A"; // not available in API yet
          const creditHistoryAge =
            companyCibil.monthsSinceOldestTradeOpened ?? "N/A";
          const cmrScore = companyCibil.cibilMsmeScore ?? "N/A";
          const comp_totalOutstandingAmount = companyCibil.totalOutstandingAmount ?? "N/A";

          //  Update bureau section
          setBureauDetailsFields({
            left: [
              ["Score", proprietorCB],
              ["Total Outstanding", totalAdvanceBalance],
              ["Total Live tradelines", totalAccounts],
              ["Bureau Age", BureauAge],
            ],
            right: [
              ["CMR Rank", cmrScore],
              ["Total Outstanding", comp_totalOutstandingAmount],
              ["DPD Months30+", DPD_Months30],
              ["Bureau Age", creditHistoryAge],
            ],
          });
        } else {
          console.error("Bureau API Error:", scoresData.error);
        }
      } catch (error) {
        console.error(" Failed to fetch bureau details:", error);
      }
    };

    fetchBureauDetails();
  }, [selectedApplication]);

  //creditmemotab
  const [creditMemoFields, setCreditMemoFields] = useState(
    {
      left: [
        ["Individual - DTI", "N/A"],
        ["Income Growth", "N/A"],
        ["Bureau Score", "N/A"],
        ["CIty", "N/A"],
      ],
      right: [
        ["Debt/Networth", "N/A"],
        ["PAT/Revenue", "N/A"],
        ["CMR Rank", "N/A"],
        ["Company Age", "N/A"],
      ]
    }
  );
  useEffect(() => {
    if (!selectedApplication) return;

    const fetchCreditMemoDetails = async () => {
      try {
        const [
          financialsRes,
          companyFinancialsRes,
          cibilRes,
          companyCibilRes,
          companyageRes,
          bscore,
        ] = await Promise.all([
          fetch(`${API_BASE}/applications/${selectedApplication}/financials`),
          fetch(`${API_BASE}/applications/${selectedApplication}/company-financials`),
          fetch(`${API_BASE}/silver/cibil/${selectedApplication}`),
          fetch(`${API_BASE}/silver/company-cibil/${selectedApplication}`),
          fetch(`${API_BASE}/applications/${selectedApplication}/individuals`),
          fetch(`${API_BASE}/individuals/${selectedApplication}/scores`),
        ]);
        const scoresData = await bscore.json();
        const financials = await financialsRes.json();
        const companyFData = await companyFinancialsRes.json();
        const cibilData = await cibilRes.json();
        const companyCibil = await companyCibilRes.json();
        const companyage = await companyageRes.json();
        console.log('financials', financials)

        const proprietor_bscore = scoresData.data?.proprietor || {};

        const pr = financials?.financials?.pr?.[0] || {};
        const comInfo = companyFData?.companyFinancials || {};
        console.log('cominfo', comInfo)
        const comInfodata = comInfo.length
          ? comInfo.reduce((latest, record) => {
            const latestYear = parseInt(latest.Assessment_Year || latest.YearID || 0);
            const currentYear = parseInt(record.Assessment_Year || record.YearID || 0);
            return currentYear > latestYear ? record : latest;
          })
          : {};
        console.log('COMINFODATA', comInfodata)

        const cibil = cibilData?.data || {};
        console.log('cibil for creditmemo', cibil)
        const compCibil = companyCibil?.data || {};
        console.log('pr detail for creditmemo', pr.Debt_To_Income)
        const compage = companyage.company;

        // ------------------------------
        // Derived Values
        // ------------------------------

        //  Individual DTI
        const individualDTI = pr.Debt_To_Income ?? "N/A";

        //  Income Growth (PR latest vs CO latest is unclear → using PR income growth)
        const incomeGrowth = pr.Income_Growth ?? "N/A";

        //  Bureau Score (Proprietor CB Score)
        const bureauScore = proprietor_bscore.scores?.cb ?? "N/A";

        //  City
        const city = proprietor_bscore.city ?? "N/A";

        //  Debt / Networth
        const debtToNetworth = comInfodata.DebtToNetworth ?? "N/A";

        //  PAT / Revenue
        const patRevenue = comInfodata.PATMargin ?? "N/A";

        //  CMR Rank (company CIBIL)
        const cmrRank = compCibil.cibilMsmeScore ?? "N/A";

        //  Company Age (years)
        const companyAge = compage.Age_of_Company ?? "N/A";

        // ------------------------------
        //  Update UI
        // ------------------------------
        setCreditMemoFields({
          left: [
            ["Individual - DTI", individualDTI],
            ["Income Growth", incomeGrowth],
            ["Bureau Score", bureauScore],
            ["City", city],
          ],
          right: [
            ["Debt/Networth", debtToNetworth],
            ["PAT/Revenue", patRevenue],
            ["CMR Rank", cmrRank],
            ["Company Age", companyAge],
          ],
        });
      } catch (error) {
        console.error(" Failed to fetch credit memo details:", error);
      }
    };

    fetchCreditMemoDetails();
  }, [selectedApplication]);


  //status useeffect
  useEffect(() => {
    if (!selectedApplication) return;

    const fetchStatus = async () => {
      try {
        console.log("Fetching status for:", selectedApplication);
        const res = await fetch(`${API_BASE}/applications/${selectedApplication}/status`);
        const json = await res.json();
        if (!res.ok) {
          console.error("Backend returned an error:", json);
          setFinalStatus("N/A");
          return;
        }
        setFinalStatus(json.data?.finalStatus ?? "N/A");
        console.log("Final Status:", json.data?.finalStatus);
      } catch (err) {
        console.error("Fetch error:", err);
        setFinalStatus("N/A");
      }
    };

    fetchStatus();
  }, [selectedApplication]);


  //memono and date useeffect
  useEffect(() => {
    if (!selectedApplication) return;

    const fetchSilverLoanData = async () => {
      try {
        const res = await fetch(`${API_BASE}/silver/loanapplications/${selectedApplication}`);
        const json = await res.json();
        console.log("Silver API Response:", json); // <-- keep this to verify

        if (json.success && json.data) {
          setMemoNo(json.data?.loanApplicationRegistrationNo ?? "N/A");

          const rawDate = json.data?.loanApplicationRegistrationDate;


          setMemoDate(rawDate ?? "N/A");
          // setMemoDate(json.data?.registrationDate ?? "N/A");



        } else {
          setMemoNo("N/A");
          setMemoDate("N/A");
        }

      } catch (err) {
        console.error("Silver Loan Fetch Error:", err);

        setMemoNo("N/A");
        setMemoDate("N/A");
      }
    };

    fetchSilverLoanData();
  }, [selectedApplication]);



  //  Step 1A: Preselect from URL query param (?id=LOS0000001)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const idFromQuery = params.get("id");
    if (idFromQuery && typeof idFromQuery === 'string' && idFromQuery.trim()) {
      console.log(' [URL PARAM] Setting application from URL:', idFromQuery);
      safeSetSelectedApplication(idFromQuery.trim());
    }
    // do not clear query here
  }, [location.search]);

  // Step 1B: Preserve verified/selected application from location.state
  useEffect(() => {
    const verifiedId = location.state?.verifiedId || location.state?.applicationNo;
    if (verifiedId && typeof verifiedId === 'string' && verifiedId.trim()) {
      console.log(' [LOCATION STATE] Setting application from state:', verifiedId);
      safeSetSelectedApplication(verifiedId.trim());
      setVerifiedApplications((prev) => new Set([...prev, verifiedId.trim()]));
      window.history.replaceState({}, document.title); // clear state
    }
  }, [location.state]);

  // Load applications from backend
  useEffect(() => {
    const ctrl = new AbortController();
    getAllApplications({ page: 1, limit: 50 }, { signal: ctrl.signal })
      .then((res) => {
        // Check if aborted before processing
        if (ctrl.signal.aborted) return;
        
        const list = Array.isArray(res?.applications)
          ? res.applications.filter(Boolean)  //  Store full application objects
          : [];
        setApplications(list);
        // If no selection yet but URL has none, preselect first result
        if (!selectedApplication && list.length > 0) {
          const firstAppId = list[0]?.applicationNo;
          if (typeof firstAppId === 'string' && firstAppId.trim()) {
            console.log(' [AUTO SELECT] Setting first application:', firstAppId);
            safeSetSelectedApplication(firstAppId.trim());
          }
        }
      })
      .catch((e) => {
        // Silently ignore AbortError - it's expected when component unmounts
        if (e.name === 'AbortError') {
          console.log('[SUMMARY] Request aborted (expected behavior)');
          return;
        }
        console.error('Failed to load applications:', e.message || e);
        setApplications([]);
      });
    return () => {
      ctrl.abort();
    };
  }, []);

  // Fetch individuals for flipping cards when an application
  // useEffect(() => {
  //   if (!selectedApplication) return;
  //   const ctrl = new AbortController();

  //   getApplicationDetails(selectedApplication, { signal: ctrl.signal })
  //     .then((data) => {
  //       const applicants = data?.data?.applicants || {};
  //       console.log('Summary applicants debug:', {
  //         applicationId: selectedApplication,
  //         raw: data?.data,
  //         applicants,
  //       });

  //       const normalize = (v) => (typeof v === 'string' ? v.trim() : v ?? '');

  //       const company = applicants.company || {};
  //       const proprietor = applicants.proprietor || {};
  //       const co = applicants.coApplicant || {};

  //       console.log('Mapped cards preview:', {
  //         proprietor: {
  //           name: normalize(proprietor.name) || 'N/A',
  //           phone: normalize(proprietor.phone) || 'N/A',
  //           pan: normalize(proprietor.pan) || 'N/A',
  //           email: normalize(proprietor.email) || 'N/A',
  //         },
  //         coApplicant: {
  //           name: normalize(co.name) || 'N/A',
  //           phone: normalize(co.phone) || 'N/A',
  //           pan: normalize(co.pan) || 'N/A',
  //           email: normalize(co.email) || 'N/A',
  //         },
  //         company: {
  //           name: normalize(company.name) || 'N/A',
  //           phone: normalize(company.phone) || 'N/A',
  //           pan: normalize(company.pan) || 'N/A',
  //           email: normalize(company.email) || 'N/A',
  //         },
  //       });

  //       setPeopleCards([
  //         {
  //           role: 'Proprietor',
  //           name: normalize(proprietor.name) || 'N/A',
  //           phone: normalize(proprietor.phone) || 'N/A',
  //           pan: normalize(proprietor.pan) || 'N/A',
  //           email: normalize(proprietor.email) || 'N/A',
  //         },
  //         {
  //           role: 'Co-Applicant',
  //           name: normalize(co.name) || 'N/A',
  //           phone: normalize(co.phone) || 'N/A',
  //           pan: normalize(co.pan) || 'N/A',
  //           email: normalize(co.email) || 'N/A',
  //         },
  //         {
  //           role: 'Company',
  //           name: normalize(company.name) || 'N/A',
  //           phone: normalize(company.phone) || 'N/A',
  //           pan: normalize(company.pan) || 'N/A',
  //           email: normalize(company.email) || 'N/A',
  //         },
  //       ]);
  //     })
  //     .catch((e) => {
  //       if (e.name !== 'AbortError') {
  //         console.error('Summary applicants error:', e);
  //         setPeopleCards([
  //           { name: 'N/A', role: 'Proprietor', phone: 'N/A', pan: 'N/A', email: 'N/A' },
  //           { name: 'N/A', role: 'Co-Applicant', phone: 'N/A', pan: 'N/A', email: 'N/A' },
  //           { name: 'N/A', role: 'Company', phone: 'N/A', pan: 'N/A', email: 'N/A' },
  //         ]);
  //       }
  //     });

  //   return () => ctrl.abort();
  // }, [selectedApplication]);

  //17/11

  const getImageByRoleGender = (role, gender) => {
    const g = gender?.toLowerCase();

    // Company → building
    if (role === "Company") return buildingImg;

    // If gender missing → return default applicant icon
    if (!g || g === "null" || g === "undefined") {
      return defualtuser;
    }

    // Proprietor / Co-Applicant use gender
    if (role === "Proprietor" || role === "Co-Applicant") {
      return g === "female" ? femaleImg : maleImg;
    }

    // Default fallback
    return defualtuser;
  };



  useEffect(() => {
    if (!selectedApplication) return;

    const fetchAllData = async () => {
      try {
        // --- LOAN APPLICATION DETAILS ---
        const loanRes = await fetch(
          `${API_BASE}/silver/loanapplications/${selectedApplication}`
        );
        const loanResult = await loanRes.json();
        if (!loanResult.success) return;

        const loan = loanResult.data;

        // --- FETCH AADHAAR DATA FOR ROLES ---
        const roles = [
          { ui: "Proprietor", db: "PR" },
          { ui: "Co-Applicant", db: "CO1" },
          { ui: "Company", db: null } // Company has NO Aadhaar entry
        ];

        const aadhaarPromises = roles.map((r) => {
          if (!r.db) {
            console.log(`Skipping Aadhaar fetch for ${r.ui}`);
            return Promise.resolve({ success: true, data: { gender: null } });
          }

          console.log(`Fetching Aadhaar for ${r.ui} using DB role ${r.db}`);

          return fetch(
            `${API_BASE}/silver/adharapplications/${selectedApplication}?role=${r.db}`
          ).then((res) => res.json());
        });




        const aadhaarResults = await Promise.all(aadhaarPromises);
        console.log("Aadhaar API Raw Results:", aadhaarResults);
        // Print individual role data
        roles.forEach((role, i) => {
          console.log(`→ Role: ${role.ui} | API Result:`, aadhaarResults[i]);
        });



        // Extract gender for each role (or null)
        const genderMap = {
          Proprietor: aadhaarResults[0]?.data?.gender || null,
          "Co-Applicant": aadhaarResults[1]?.data?.gender || null,
          Company: null
        };


        // --- UPDATE PEOPLE CARDS ---
        const updatedCards = [
          {
            role: "Proprietor",
            gender: genderMap.Proprietor,
            name: loan.nameOfBorrowerProprietor || "N/A",
            phone: loan.phoneProprietor || "N/A",
            pan: loan.panProprietor || "N/A",
            email: loan.emailProprietor || "N/A",
            img: getImageByRoleGender("Proprietor", genderMap.Proprietor),
          },
          {
            role: "Co-Applicant",
            gender: genderMap["Co-Applicant"],
            name: loan.nameOfCoApplicant || "N/A",
            phone: loan.phoneCoApplicant || "N/A",
            pan: loan.panCoApplicant || "N/A",
            email: loan.emailCoApplicant || "N/A",
            img: getImageByRoleGender("Co-Applicant", genderMap["Co-Applicant"]),
          },
          {
            role: "Company",
            gender: "Company",
            name: loan.nameOfBorrowerProprietorship || "N/A",
            phone: loan.phoneProprietorship || "N/A",
            pan: loan.panProprietorship || "N/A",
            email: loan.emailProprietorship || "N/A",
            img: buildingImg,
          },
        ];



        // Ensure all properties are strings to prevent object rendering errors
        const safeUpdatedCards = updatedCards.map(card => ({
          ...card,
          name: typeof card.name === 'string' ? card.name : 'N/A',
          role: typeof card.role === 'string' ? card.role : 'N/A',
          phone: typeof card.phone === 'string' ? card.phone : 'N/A',
          pan: typeof card.pan === 'string' ? card.pan : 'N/A',
          email: typeof card.email === 'string' ? card.email : 'N/A',
          gender: typeof card.gender === 'string' ? card.gender : null
        }));

        setPeopleCards(safeUpdatedCards);
      } catch (err) {
        console.error("Error fetching details:", err);
      }
    };

    fetchAllData();
  }, [selectedApplication]);



  //  Check if application is verified (either manually marked OR verification is 100%)
  const isCurrentApplicationVerified = (() => {
    // Ensure selectedApplication is a valid string
    if (!selectedApplication || typeof selectedApplication !== 'string') return false;

    // Check if manually verified
    if (verifiedApplications.has(selectedApplication)) {
      console.log(" Manually verified:", selectedApplication);
      return true;
    }

    // Check if verification is 100% complete
    const app = applications.find(a => a.id === selectedApplication || a.applicationNo === selectedApplication);
    console.log(" Checking verification for:", selectedApplication, "| Found app:", app, "| Verification:", app?.verification);

    if (app && app.verification && typeof app.verification === 'string') {
      try {
        const [verified, total] = app.verification.split('/').map(Number);
        console.log(`Verification: ${verified}/${total} = ${verified >= total ? "VERIFIED " : "NOT VERIFIED ❌"}`);
        if (total > 0 && verified >= total) {
          return true;  // 100% verified
        }
      } catch (e) {
        console.error(" Error parsing verification:", e);
      }
    }

    return false;
  })();

  const handleVerifyClick = () => {
    // Ensure we have a valid string ID
    const idToOpen = typeof selectedApplication === 'string' && selectedApplication 
      ? selectedApplication 
      : 'LOS0000001';
    
    console.log(' [VERIFY CLICK] Navigating to application detail:', idToOpen);
    
    try {
      navigate(`/applicationdetail/${encodeURIComponent(idToOpen)}`, {
        state: {
          applicationNo: idToOpen,
          returnTo: "/applicationsummary",
        },
      });
    } catch (error) {
      console.error(' [VERIFY CLICK] Navigation error:', error);
      // Fallback navigation without encoding if there's an issue
      navigate(`/applicationdetail/${idToOpen}`, {
        state: {
          applicationNo: idToOpen,
          returnTo: "/applicationsummary",
        },
      });
    }
  };

  //  Keep the selected value in the URL while user is on this page
  useEffect(() => {
    const current = new URLSearchParams(location.search).get("id");
    if (!selectedApplication && !current) return; // nothing to sync
    
    // Ensure selectedApplication is a valid string before using it in URL
    const safeSelectedApp = typeof selectedApplication === 'string' && selectedApplication.trim() 
      ? selectedApplication.trim() 
      : '';
    
    const nextSearch = safeSelectedApp
      ? `?id=${encodeURIComponent(safeSelectedApp)}`
      : "";
      
    if (location.search !== nextSearch) {
      console.log(' [URL SYNC] Updating URL with application:', safeSelectedApp);
      navigate({ pathname: location.pathname, search: nextSearch }, { replace: true });
    }
  }, [selectedApplication, location.pathname, location.search, navigate]);

  return (
    <Box
      sx={{
        display: "flex",
        bgcolor: "#fff",
        minHeight: "100vh",
        fontFamily: '"Nunito Sans", "Roboto", "Arial", sans-serif',
      }}
    >
      <Sidebar
        collapsed={collapsed}
        onToggleSidebar={() => setCollapsed(!collapsed)}
        onLogout={handleLogout}
      />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          overflow: "hidden",
        }}
      >
        <Header collapsed={collapsed} />

        <Box
          sx={{
            flexGrow: 1,
            width: "100%",
            p: { xs: "1rem", md: "1.5rem" },
            px: { xs: "1rem", md: "2.5rem" },
            mt: { xs: "1rem", md: "1.5rem" },
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {/* 🔹 Top Row: Autocomplete + Title */}
       <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    alignItems: { xs: "stretch", sm: "center" },
    justifyContent: "space-between",
    gap: "1rem",
    mb: "1rem",
    mt: "1rem",
    width: "100%",
  }}
>
  {/* Application Autocomplete */}
  <Box
    sx={{
      width: { xs: "100%", sm: "16rem" },
      mt: { xs: "1rem", sm: 0 },
      mb: "0.5rem",
      flexShrink: 0,
    }}
  >
    <Autocomplete
      options={applications}
      getOptionLabel={(option) => option?.applicationNo || option || ""}
      value={applications.find(a => a.applicationNo === selectedApplication) || selectedApplication || null}
      onChange={(e, newValue) => {
        // Ensure we only set string values using the safe wrapper
        const safeValue = typeof newValue === 'string' ? newValue : newValue?.applicationNo;
        if (typeof safeValue === 'string' && safeValue) {
          safeSetSelectedApplication(safeValue);
        } else {
          safeSetSelectedApplication('');
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Application No..."
          variant="outlined"
          size="small"
          sx={{
            height: { xs: "3rem", sm: "3.5rem" },
            width: "100%",
            ...commonFieldStyles,
            backgroundColor: "#C7C7C7",
            borderRadius: "0.75rem",
            "& .MuiOutlinedInput-root": {
              height: "100%",
              width: "100%",
              justifyContent: "center",
              borderRadius: "0.75rem",
              "& fieldset": { 
                border: "none",
                borderRadius: "0.75rem",
              },
              "&:hover fieldset": { 
                border: "none",
                borderRadius: "0.75rem",
              },
              "&.Mui-focused fieldset": { 
                border: "none",
                borderRadius: "0.75rem",
              },
            },
            "& .MuiInputBase-input": {
              fontWeight: 600,
              fontSize: { xs: "1rem", sm: "1.25rem" },
              textAlign: "center",
              padding: { xs: "0 0.5rem", sm: "0" },
              color: "#034A7F",
              whiteSpace: "nowrap",
              overflowX: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
              "&::placeholder": {
                color: "#034A7F",
                opacity: 1,
                fontWeight: 600,
                fontSize: { xs: "1rem", sm: "1.25rem" },
              },
            },
            "& .MuiAutocomplete-endAdornment": {
              right: { xs: "0.5rem", sm: "0.75rem" },
            },
          }}
        />
      )}
    />
  </Box>

  {/* Verify button aligned with search */}
  {selectedApplication && (
    <Box sx={{ 
      display: "flex", 
      alignItems: "center",
      width: { xs: "100%", sm: "auto" },
      justifyContent: { xs: "flex-start", sm: "center" },
    }}>
      {isCurrentApplicationVerified ? (
        <Button
          onClick={() => {
            const safeId = typeof selectedApplication === 'string' && selectedApplication.trim() 
              ? selectedApplication.trim() 
              : 'LOS0000001';
            console.log('[VERIFIED CLICK] Navigating to application detail:', safeId);
            try {
              navigate(`/applicationdetail/${encodeURIComponent(safeId)}`);
            } catch (error) {
              console.error(' [VERIFIED CLICK] Navigation error:', error);
              navigate(`/applicationdetail/${safeId}`);
            }
          }}
          sx={{
            color: "#fff",
            borderRadius: "8px",
            padding: { xs: "8px 20px", sm: "6px 16px" },
            boxShadow: "none",
            background: "#5ABA85",
            border: "1px solid #5ABA85",
            cursor: "pointer",
            width: { xs: "100%", sm: "auto" },
            minWidth: { xs: "100%", sm: "120px" },
            "&:hover": {
              background: "#4da574",
            },
            "& .MuiButton-label": {
              fontSize: { xs: "15px", sm: "16px" },
              fontWeight: 600,
              textTransform: "none",
            },
          }}
          startIcon={
            <img
              src={verifiedGreen}
              alt="Verified"
              style={{
                width: { xs: "18px", sm: "20px" },
                height: { xs: "18px", sm: "20px" },
                filter: "brightness(0) invert(1)"
              }}
            />
          }
        >
          Verified
        </Button>
      ) : (
        <Button
          sx={{
            color: "#fff",
            borderRadius: "8px",
            padding: { xs: "8px 20px", sm: "6px 16px" },
            boxShadow: "none",
            background: "#ff7769",
            border: "1px solid #ff7769",
            width: { xs: "100%", sm: "auto" },
            minWidth: { xs: "100%", sm: "140px" },
            "& .MuiButton-label": {
              fontSize: { xs: "15px", sm: "16px" },
              fontWeight: 600,
              textTransform: "none",
            },
          }}
          startIcon={
            <img
              src={verifiedGrey}
              alt="Not Verified"
              style={{
                width: { xs: "18px", sm: "20px" },
                height: { xs: "18px", sm: "20px" },
                filter: "brightness(0) invert(1)"
              }}
            />
          }
          onClick={handleVerifyClick}
        >
          Not Verified
        </Button>
      )}
    </Box>
  )}
</Box>

          {!selectedApplication && (
            <Emptysummary />
          )}

          {selectedApplication && (
            <>
              {/* Tabs + Verification */}
         <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", sm: "row" },
    justifyContent: "space-between",
    alignItems: { xs: "flex-start", sm: "center" },
    gap: { xs: "0.5rem", sm: "1rem" },
    mb: { xs: "1rem", sm: "1.5rem" },
    width: "100%",
  }}
>
  <Box
    sx={{
      flex: 1,
      width: "100%",
      border: "none",
      borderRadius: 0,
      overflow: { xs: "auto", sm: "visible" },
      "&::-webkit-scrollbar": {
        display: "none", // Hide scrollbar
      },
    }}
  >
    <Tabs
      value={activeTab}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons="auto"
      allowScrollButtonsMobile
      sx={{
        width: "100%",
        minHeight: { xs: "2.25rem", sm: "2.5rem" },
        "& .MuiTab-root": {
          textTransform: "none",
          fontWeight: 600,
          minHeight: { xs: "2.25rem", sm: "2.5rem" },
          padding: { xs: "0.25rem 0.5rem", sm: "0.25rem 0.5rem" },
          color: "#034A7F",
          minWidth: { xs: "fit-content", sm: 0 },
          flex: { xs: "0 0 auto", sm: 1 },
          fontSize: { xs: "0.875rem", sm: "1rem" },
          whiteSpace: "nowrap",
        },
        "& .MuiTab-root.Mui-selected": {
          color: "#034A7F",
        },
        "& .MuiTabs-indicator": {
          backgroundColor: "#034A7F",
          height: "0.2rem",
        },
        "& .MuiTabs-scrollButtons": {
          color: "#034A7F",
          width: { xs: "1.5rem", sm: "2rem" },
          "&.Mui-disabled": {
            opacity: 0.3,
          },
        },
      }}
    >
      {tabLabels.map((label, index) => (
        <Tab
          key={index}
          label={
            <Box 
              display="flex" 
              alignItems="center" 
              gap={{ xs: "0.25rem", sm: "0.5rem" }}
              sx={{ whiteSpace: "nowrap" }}
            >
              <span>{label}</span>
              {/* {index === 0 && (
                <img
                  src={applicationicon}
                  alt="application"
                  style={{ 
                    width: { xs: "1rem", sm: "1.125rem" }, 
                    height: { xs: "1rem", sm: "1.125rem" } 
                  }}
                />
              )}
              {index === 1 && (
                <img
                  src={financeicon}
                  alt="finance"
                  style={{ 
                    width: { xs: "1rem", sm: "1.125rem" }, 
                    height: { xs: "1rem", sm: "1.125rem" } 
                  }}
                />
              )} */}
            </Box>
          }
        />
      ))}
    </Tabs>
  </Box>
  {/* Verify button moved to top row */}
</Box>


              {/*  Business Header Section */}
              <Card
                sx={{
                  mb: "1rem",
                }}
              >
                <CardContent
                  sx={{
                    p: "0.5rem",
                    "&:last-child": { pb: "0.5rem" },
                  }}
                >
                  <Grid
                    container
                    spacing={{ xs: "0.5rem", sm: "1rem" }}
                    alignItems="center"
                    sx={{ flexDirection: { xs: "column", md: "row" } }}
                  >
                    {/* Left Column */}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.5, // space between image & text
                        }}
                      >
                        {/* Home Image */}
                        <Box
                          component="img"
                          src={homeicon} // <-- replace with your image path
                          alt="Home"
                          sx={{
                            width: { xs: "1.5rem", sm: "1.5rem", md: "1.5rem" },
                            height: "auto",
                            borderRadius: "0.25rem",
                          }}
                        />

                        {/* Title */}
                        <Typography
                          variant="h6"
                          fontWeight="600"
                          color="#034A7F"
                          sx={{
                            fontSize: { xs: "1rem", sm: "1.3rem" },
                          }}
                        >
                          Raksha Solar House
                        </Typography>
                      </Box>
                    </Grid>

                    {/* Right Column */}
                    <Grid item xs={12} md={6}>
                      <Box
                        sx={{
                          marginLeft: { md: 3 },
                          display: "grid",
                          gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "auto auto auto auto" },
                          columnGap: 4,
                          rowGap: 1,
                          width: "100%",
                          justifyContent: { md: "flex-end" },
                        }}
                      >
                        {[
                          { label: "Application No:", value: selectedApplication || "N/A", width: "260px" },
                          { label: "Memo No:", value: memoNo, width: "200px" },
                          { label: "Date:", value: memoDate, width: "130px" },
                          { label: "Status:", value: finalStatus, width: "150px" },
                        ].map((item, index) => (
                          <Box
                            key={index}
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "max-content 1fr",
                              columnGap: 0.5,
                              alignItems: "center",
                              width: item.width, // 🔹 DYNAMIC WIDTH BASED ON FIELD
                            }}
                          >
                            {/* Label */}
                            <Typography
                              sx={{
                                fontWeight: 600,
                                color: "#034A7F",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {item.label}
                            </Typography>

                            {/* Value */}
                            <Typography
                              sx={{
                                color: "#C7C7C7",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}
                            >
                              {item.value}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Grid>




                  </Grid>

                </CardContent>
              </Card>

              {/*  loan details + Applicant  */}



              <Grid container spacing={2} alignItems="stretch" paddingTop={1}>
                {/* Loan Details */}
                {(() => {
                  const fields =
                    activeTab === 0 ? profileDetailsFields :
                      activeTab === 1 ? financialDetailsFields :
                        activeTab === 2 ? bureauDetailsFields :
                          creditMemoFields;
                  return (
                    <>
                      <Grid item xs={12} md={4} sx={{
                        flexShrink: 0, //  Prevent grid item from shrinking
                        maxWidth: { xs: "100%", md: "34%" }, //  Strict width limit
                        flexBasis: { xs: "100%", md: "34%" }, //  Fixed basis
                      }}>
                        <Card
                          sx={{
                            borderRadius: "16px",
                            pt: 2,
                            px: 4,
                            pb: 0,
                            boxShadow: 3,
                            width: "100%", //  Takes full width of Grid item
                            maxWidth: "100%", //  Never exceed Grid item
                            minWidth: 0, //  Allow content to be constrained
                            boxSizing: "border-box", //  Include padding in width
                            height: { xs: "auto", md: "100%" },

                            display: "flex",
                            flexDirection: "column",
                            position: "relative",
                            overflow: "hidden",
                            transition: "color 0.4s ease-in-out",
                            zIndex: 0,
                            cursor: "pointer",

                            // --- Hover Effect ---
                            "&:hover": {
                              color: "white",

                              // Make all Typography text turn white
                              "& .MuiTypography-root": {
                                color: "white",
                                transition: "color 0.4s ease-in-out",
                              },

                              // Only the values should be grey on hover
                              "& .value-text": {
                                color: "#C7C7C7 !important",
                              },

                              // Activate the fill layer
                              "&::after": {
                                transform: "scaleY(1)",
                              },
                            },

                            // --- Background Fill Layer (Bottom to Top Animation) ---
                            "&::after": {
                              content: '""',
                              position: "absolute",
                              bottom: 0,
                              left: 0,
                              width: "100%",
                              height: "100%",
                              backgroundColor: "#034A7F",
                              zIndex: -1,
                              transform: "scaleY(0)",
                              transformOrigin: "bottom",
                              transition: "transform 0.4s ease-in-out",
                            },
                          }}
                        >
                          <CardContent
                            sx={{
                              flex: 1,
                              width: "100%", //  Constrain content width
                              minWidth: 0, //  Allow flex shrinking
                              overflow: "hidden", //  Hide any overflow
                            }}
                          >
                            <Grid container spacing={2}>
                              {/* Left column */}
                              <Grid
                                item
                                xs={12}
                                sm={6}
                                ml={-2}

                                sx={{
                                  minWidth: 0, //  Allow grid item to shrink
                                  maxWidth: { xs: "100%", sm: "45%" }, //  Constrain width
                                  flexBasis: { xs: "100%", sm: "45%" }, //  Fixed 50% width
                                  flexShrink: 0, //  Prevent shrinking
                                }}
                              >
                                {fields.left.map(([label, value], i) => (
                                  <Box
                                    key={i}
                                    mb={2}
                                    sx={{
                                      minWidth: 0, //  Allow box to shrink
                                      maxWidth: "100%", //  Prevent overflow
                                      overflow: "hidden", //  Hide overflow
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#034A7F",
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%", //  Take full width
                                        display: "block", //  Ensure block display
                                      }}
                                    >
                                      {label}
                                    </Typography>

                                    <Typography
                                      className="value-text"
                                      sx={{
                                        color: "#C7C7C7",
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%", // Take full width
                                        display: "block", //  Ensure block display
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Box>
                                ))}
                              </Grid>

                              {/* Right column */}
                              <Grid
                                item
                                xs={12}
                                sm={6}

                                sx={{
                                  minWidth: 0, //  Allow grid item to shrink
                                  maxWidth: { xs: "100%", sm: "50%" }, //  Constrain width
                                  flexBasis: { xs: "100%", sm: "50%" }, //  Fixed 50% width
                                  flexShrink: 0, //  Prevent shrinking
                                }}
                              >
                                {fields.right.map(([label, value], i) => (
                                  <Box
                                    key={i}
                                    mb={2}
                                    sx={{
                                      minWidth: 0, //  Allow box to shrink
                                      maxWidth: "100%", //  Prevent overflow
                                      overflow: "hidden", //  Hide overflow
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: "#034A7F",
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%", //  Take full width
                                        display: "block", // Ensure block display
                                      }}
                                    >
                                      {label}
                                    </Typography>

                                    <Typography
                                      className="value-text"
                                      sx={{
                                        color: "#C7C7C7",
                                        fontSize: "0.85rem",
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        width: "100%", //  Take full width
                                        display: "block", //  Ensure block display
                                      }}
                                    >
                                      {value}
                                    </Typography>
                                  </Box>
                                ))}
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                    </>
                  );
                })()}


                {peopleCards.map((person, index) => {
                  console.log(
                    `Role: ${person.role} | Gender: ${person.gender}`
                  );

                  // Ensure person properties are strings to prevent object rendering
                  const safePerson = {
                    ...person,
                    name: typeof person.name === 'string' ? person.name : 'N/A',
                    role: typeof person.role === 'string' ? person.role : 'N/A',
                    phone: typeof person.phone === 'string' ? person.phone : 'N/A',
                    pan: typeof person.pan === 'string' ? person.pan : 'N/A',
                    email: typeof person.email === 'string' ? person.email : 'N/A',
                    gender: typeof person.gender === 'string' ? person.gender : null,
                    img: person.img || defualtuser
                  };

                  return (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md
                      sx={{
                        flex: { xs: "0 0 100%", sm: 1 },
                        maxWidth: { xs: "100%", sm: "none" },
                        display: "flex",
                      }}
                      key={index}
                    >
                      <Box
                        sx={{
                          flex: 1,
                          perspective: "1000px",
                          height: { xs: "auto", md: "100%" },
                          display: "flex",
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            transformStyle: "preserve-3d",
                            transition: "transform 0.6s",
                            "&:hover": { transform: "rotateY(180deg)" },
                          }}
                        >
                          {/* Front Side */}
                          <Card
                            sx={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              backfaceVisibility: "hidden",
                              borderRadius: "16px",
                              boxShadow: 3,
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: 1,
                              p: 2,
                              cursor: "pointer",
                              bgcolor: "white",
                            }}
                          >
                            <Box
                              component="img"
                              src={safePerson.img || defualtuser}
                              alt={safePerson.name}
                              sx={{
                                width: "100%",
                                maxWidth: 180,
                                height: "auto",
                                objectFit: "cover",
                                borderRadius: "50%",
                              }}
                            />
                            <Divider sx={{ width: "calc(100% + 32px)", my: 1, mx: "-16px" }} />
                            <Typography fontWeight={600} sx={{ color: '#034A7F' }}>{safePerson.name}</Typography>
                            <Typography variant="body2" sx={{ color: '#034A7F' }}>{safePerson.role}</Typography>
                          </Card>

                          {/* Back Side */}
                          {/* <Card
                          sx={{
                            position: "absolute",
                            inset: 0,
                            backfaceVisibility: "hidden",
                            borderRadius: "16px",
                            boxShadow: 6,
                            transform: "rotateY(180deg)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            bgcolor: "#fff",
                            p: 3,
                            transition: "all 0.3s ease",
                            "&:hover": { boxShadow: "0px 8px 25px rgba(0,0,0,0.15)" },
                          }}
                        >
                          <Box display="flex" alignItems="center" gap={1} mb={1}>
                            <Box component="img" src={applicanticon} alt="applicant" sx={{ width: 18, height: 22, color: "#034A7F" }} />
                            <Typography fontWeight={700} fontSize="1.1rem" color="#034A7F">{person.name}</Typography>
                          </Box>
                          <Typography variant="body2" sx={{ color: "#034A7F", mb: 1.5 }}>{person.role}</Typography>
                          <Divider sx={{ width: "70%", mb: 2 }} />
                          <Box display="flex" alignItems="center" gap={1} mb={1}>
                            <Box component="img" src={phoneicon} alt="phone" sx={{ width: 18, height: 18 }} />
                            <Typography variant="body2" fontWeight={600} sx={{ color: "#034A7F" }}>+91  <span style={{ fontWeight: 600, color: "#C7C7C7" }}>{person.phone}</span></Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Box component="img" src={panicon} alt="pan" />
                            <Typography variant="body2" fontWeight={600} sx={{ color: "#034A7F" }}>PAN: <span style={{ fontWeight: 600, color: "#C7C7C7" }}>{person.pan}</span></Typography>
                          </Box>
                          <Box display="flex" alignItems="center" gap={1} mt={1}>
                            <Box component="img" src={emailicon} alt="email" />
                            <Typography variant="body2" sx={{ fontWeight: 600, color: "#034A7F", fontSize: "0.8rem" }}>Email: <span style={{ color: "#C7C7C7" }}>{person.email}</span></Typography>
                          </Box>
                        </Card> */}
                          <Card
                            sx={{
                              position: "absolute",
                              inset: 0,
                              backfaceVisibility: "hidden",
                              borderRadius: "16px",
                              boxShadow: 6,
                              transform: "rotateY(180deg)",
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              bgcolor: "#fff",
                              p: 3,
                              transition: "all 0.3s ease",
                              "&:hover": { boxShadow: "0px 8px 25px rgba(0,0,0,0.15)" },
                            }}
                          >

                            {/* Name */}
                            <Box display="flex" alignItems="center" gap={1} mb={1}>
                              <Box component="img" src={applicanticon} alt="applicant" sx={{ width: 18, height: 22 }} />
                              <Typography fontWeight={700} fontSize="1.1rem" color="#034A7F">
                                {safePerson.name}
                              </Typography>
                            </Box>

                            <Typography variant="body2" sx={{ color: "#034A7F", mb: 1.5 }}>{safePerson.role}</Typography>
                            <Divider sx={{ width: "70%", mb: 2 }} />

                            {/* Phone */}
                            <Box display="flex" alignItems="flex-start" gap={1} width="100%" mb={1}>
                              <Box component="img" src={phoneicon} alt="phone" sx={{ width: 18, height: 18, mt: "2px" }} />
                              <Typography fontWeight={600} fontSize="0.9rem" color="#C7C7C7" sx={{ flex: 1, whiteSpace: "normal", wordBreak: "break-word" }}>
                                +91 {safePerson.phone}
                              </Typography>
                            </Box>

                            {/* PAN */}
                            <Box display="flex" alignItems="flex-start" gap={1} width="100%" mb={1}>
                              <Box component="img" src={panicon} alt="pan" sx={{ width: 18, height: 18, mt: "2px" }} />
                              <Typography fontWeight={600} fontSize="0.9rem" color="#C7C7C7" sx={{ flex: 1, whiteSpace: "normal", wordBreak: "break-word" }}>
                                {safePerson.pan}
                              </Typography>
                            </Box>

                            {/* Email */}
                            <Box display="flex" alignItems="flex-start" gap={1} width="100%">
                              <Box component="img" src={emailicon} alt="email" sx={{ width: 18, height: 18, mt: "2px" }} />
                              <Typography fontWeight={400} fontSize="0.8rem" color="#C7C7C7" sx={{ flex: 1, whiteSpace: "normal", wordBreak: "break-word" }}>
                                {safePerson.email}
                              </Typography>
                            </Box>

                          </Card>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}

              </Grid>


              {/* Rest of your cards + details */}
              <Appsummary activeTab={activeTab} />
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
}
